/**
 * Exports merchant data to a CSV file
 * @param {Array} merchants - Array of merchant objects containing business details
 */
export const exportToCSV = (merchants, headers) => {
  // Create CSV content using more efficient methods
  const csvContent = [
    headers.join(","),
    ...merchants.map((merchant) => {
      const row = [];
      
      // Build row data based on header order
      headers.forEach(header => {
        switch(header) {
          case "Business Name":
            row.push(merchant.businessName);
            break;
          case "Email":
            row.push(merchant.email);
            break;
          case "Sales Rep":
            row.push(merchant.salesRep);
            break;
          case "Account Ex":
            row.push(merchant.accountEx);
            break;
          case "GW ID":
            row.push(merchant.gwId);
            break;
          case "Date Submitted":
            row.push(merchant.dateSubmitted);
            break;
          case "Date Approved":
            row.push(merchant.dateApproved);
            break;
          case "Updated Date":
            row.push(merchant.dateUpdated);
            break;
          case "Status":
            row.push(merchant.status);
            break;
          default:
            row.push("");
        }
      });
      
      return row.join(",");
    }),
  ].join("\n");

  // Create and trigger download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  // Create temporary link element for download
  const link = document.createElement("a");
  link.href = url;
  link.download = "merchants_data.csv";
  link.style.visibility = "hidden";

  // Trigger download and cleanup
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the URL object to prevent memory leaks
  URL.revokeObjectURL(url);
};
